import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RoundNumberFormatterPipe } from './round-number-formatter.pipe';
import { DateFormatterPipe } from './date-formatter.pipe';
import { DateParserPipe } from './date-parser.pipe';
import { SanitizerByTrustPipe } from './sanitizer-by-trust.pipe';
import { StaffNameFormatterPipe } from './staff-name-formatter.pipe';
import { TimeFormatterPipe } from './time-formatter.pipe';
import { WeekdayFormatterPipe } from './weekday-formatter.pipe';
import { AppointmentStatusFormatterPipe } from './appointment-status-formatter.pipe';
import { BookingTypeFormatterPipe } from './booking-type-formatter.pipe';
import { CustomerTypeFormatterPipe } from './customer-type-formatter.pipe';
import { DurationFormatterPipe } from './duration-formatter.pipe';
import { MonthFormatterPipe } from './month-formatter.pipe';
import { ProductNameFormatterPipe } from './product-name-formatter.pipe';
import { RelativeDateFormatterPipe } from './relative-date-formatter.pipe';
import { SmartWeekdayFormatterPipe } from './smart-weekday-formatter.pipe';
import { TimePeriodFormatterPipe } from './time-period-formatter.pipe';
import { TranslateArrayPipe } from './translate-array.pipe';
import { DateTimeFormatterPipe } from './date-time-formatter.pipe';
import { ReviewTypeFormatterPipe } from './review-type-formatter.pipe';
import { CalendarDateRangeFormatterPipe } from './calendar-date-range-formatter.pipe';
import { CustomerNameFormatterPipe } from './customer-name-formatter.pipe';
import { CommunicationWayFormatterPipe } from './communication-way-formatter.pipe';
import { PhoneFormatterPipe } from './phone-formatter.pipe';
import { EmailFormatterPipe } from './email-formatter.pipe';
import { NotificationTypeFormatterPipe } from './notification-type-formatter.pipe';

@NgModule({
  declarations: [
    AppointmentStatusFormatterPipe,
    BookingTypeFormatterPipe,
    CalendarDateRangeFormatterPipe,
    CommunicationWayFormatterPipe,
    CustomerNameFormatterPipe,
    CustomerTypeFormatterPipe,
    DateFormatterPipe,
    DateParserPipe,
    DateTimeFormatterPipe,
    DurationFormatterPipe,
    EmailFormatterPipe,
    MonthFormatterPipe,
    NotificationTypeFormatterPipe,
    PhoneFormatterPipe,
    ProductNameFormatterPipe,
    RelativeDateFormatterPipe,
    ReviewTypeFormatterPipe,
    RoundNumberFormatterPipe,
    SanitizerByTrustPipe,
    SmartWeekdayFormatterPipe,
    StaffNameFormatterPipe,
    TimeFormatterPipe,
    TimePeriodFormatterPipe,
    TranslateArrayPipe,
    WeekdayFormatterPipe,
  ],
  imports: [CommonModule, TranslateModule.forChild()],
  exports: [
    AppointmentStatusFormatterPipe,
    BookingTypeFormatterPipe,
    CalendarDateRangeFormatterPipe,
    CommunicationWayFormatterPipe,
    CustomerNameFormatterPipe,
    CustomerTypeFormatterPipe,
    DateFormatterPipe,
    DateParserPipe,
    DateTimeFormatterPipe,
    DurationFormatterPipe,
    EmailFormatterPipe,
    MonthFormatterPipe,
    NotificationTypeFormatterPipe,
    PhoneFormatterPipe,
    ProductNameFormatterPipe,
    RelativeDateFormatterPipe,
    ReviewTypeFormatterPipe,
    RoundNumberFormatterPipe,
    SanitizerByTrustPipe,
    SmartWeekdayFormatterPipe,
    StaffNameFormatterPipe,
    TimeFormatterPipe,
    TimePeriodFormatterPipe,
    TranslateArrayPipe,
    WeekdayFormatterPipe,
  ],
  providers: [
    AppointmentStatusFormatterPipe,
    BookingTypeFormatterPipe,
    CalendarDateRangeFormatterPipe,
    CommunicationWayFormatterPipe,
    CustomerNameFormatterPipe,
    CustomerTypeFormatterPipe,
    DateFormatterPipe,
    DateParserPipe,
    DateTimeFormatterPipe,
    DurationFormatterPipe,
    EmailFormatterPipe,
    MonthFormatterPipe,
    NotificationTypeFormatterPipe,
    PhoneFormatterPipe,
    ProductNameFormatterPipe,
    RelativeDateFormatterPipe,
    ReviewTypeFormatterPipe,
    RoundNumberFormatterPipe,
    SanitizerByTrustPipe,
    SmartWeekdayFormatterPipe,
    StaffNameFormatterPipe,
    TimeFormatterPipe,
    TimePeriodFormatterPipe,
    TranslateArrayPipe,
    WeekdayFormatterPipe,
  ],
})
export class PipesModule {}
